// src/components/common/BubbleBackground.jsx
// Animated bubble/circle decorations that float in the background

import React from "react";

const bubbles = [
  { size: 320, top: "-8%",  left: "-6%",  delay: "0s",   duration: "9s",  opacity: 0.55 },
  { size: 200, top: "60%",  left: "-4%",  delay: "1.5s", duration: "7s",  opacity: 0.45 },
  { size: 140, top: "80%",  left: "10%",  delay: "3s",   duration: "6s",  opacity: 0.35 },
  { size: 260, top: "-4%",  right: "-5%", delay: "0.8s", duration: "11s", opacity: 0.50 },
  { size: 180, top: "40%",  right: "-3%", delay: "2s",   duration: "8s",  opacity: 0.40 },
  { size: 100, top: "70%",  right: "8%",  delay: "4s",   duration: "5s",  opacity: 0.30 },
  { size: 80,  top: "30%",  left: "5%",   delay: "2.5s", duration: "7s",  opacity: 0.28 },
  { size: 60,  top: "50%",  left: "50%",  delay: "5s",   duration: "9s",  opacity: 0.22 },
];

const BubbleBackground = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0" aria-hidden="true">
      {/* Gradient base */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(135deg, #e8f4ff 0%, #f0f6ff 40%, #e0edff 70%, #f5faff 100%)",
        }}
      />

      {/* Animated bubbles */}
      {bubbles.map((b, i) => (
        <div
          key={i}
          className="absolute rounded-full"
          style={{
            width:  b.size,
            height: b.size,
            top:    b.top,
            left:   b.left   || undefined,
            right:  b.right  || undefined,
            opacity: b.opacity,
            background:
              "radial-gradient(circle at 30% 30%, rgba(255,255,255,0.90), rgba(26,125,232,0.14))",
            border: "1.5px solid rgba(255,255,255,0.65)",
            boxShadow:
              "0 4px 24px rgba(26,125,232,0.12), 0 1px 4px rgba(255,255,255,0.7) inset",
            animation: `float ${b.duration} ease-in-out infinite`,
            animationDelay: b.delay,
          }}
        />
      ))}

      {/* Subtle blue glow patches */}
      <div
        className="absolute w-96 h-96 rounded-full -top-20 -left-20 blur-3xl"
        style={{ background: "rgba(26,125,232,0.08)" }}
      />
      <div
        className="absolute w-80 h-80 rounded-full bottom-0 right-0 blur-3xl"
        style={{ background: "rgba(26,125,232,0.07)" }}
      />
    </div>
  );
};

export default BubbleBackground;
